import {
  GET_INSTANCE_CONFIG_REQUEST,
  GET_INSTANCE_CONFIG_SUCCESS,
  GET_INSTANCE_CONFIG_FAILURE
 } from '../constants'

const defaultInstanceConfigState = {
  instanceConfig: {},
  getSuccess: false
}

export default (state = defaultInstanceConfigState, action) => {

  var newState = {...state}

  switch (action.type){

    case GET_INSTANCE_CONFIG_REQUEST:
      newState.getSuccess = false;
      return newState;
    case GET_INSTANCE_CONFIG_SUCCESS:
      newState.instanceConfig = action.data;
      newState.getSuccess = true;
      return newState;
    case GET_INSTANCE_CONFIG_FAILURE:
      newState.getSuccess = false;
      return newState;
    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/instance.js